<template>
  <button
    v-bind:class="{
      lightbox__close: true,
      'lightbox__close--white': color === 'white',
      'video__pause lightbox__close--offset': $parent.name === 'lightboxVideo'
    }"
  >
    <svg class="lightbox__close__icon"><use xlink:href="#close" /></svg>
  </button>
</template>

<script>
export default {
  props: ['color']
};
</script>
